export default "<div class=\"tab dialog\">\n\n    <js-templateNonce></js-templateNonce>\n    <span>{{- label }}</span></div>";